/* eslint react/no-children-prop: "warn"*/

import React, { Component } from 'react';
import { Card, CardHeader, CardTitle, CardText } from 'material-ui/Card';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';
import CircularProgress from 'material-ui/CircularProgress';

import ModifyExercise from './ModifyExercise';
import CreateExerciseForm from './CreateExerciseForm';

import apiErrors from '../modules/apierrors';
import getErrors from '../modules/geterrors';
import languageNames from '../modules/languagenames';

import './GroupExercises.css';

import { fetchExercises, createExercise, updateExercise, deleteExercise } from '../actions/actions';

class GroupExercises extends Component {

  constructor() {
    super();

    this.state = {
      name: '',
      language: 'en-GB',
      text: '',
      mode: 'normal',
      deleteExerciseDialog: false,
      exerciseForDeletion: null,
      showCreationForm: false,
    };
  }

  componentWillMount() {
    this.props.dispatch(fetchExercises());
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.exercises.hasSaved && nextProps.exercises.hasSaved) {
      this.setState({ showCreationForm: false });
    }
  }

  resetCreateForm = () => this.setState({ ...this.state, name: '', language: 'en-GB', text: '' });

  handleOpen = (exercise) => this.setState({ deleteExerciseDialog: true, exerciseForDeletion: exercise });

  handleClose = () => this.setState({ deleteExerciseDialog: false, exerciseForDeletion: null });

  handleUpdateExercise = (id, exercise) => {
    const newExercise = { ...exercise };
    newExercise.saveToGroup = true;
    this.props.dispatch(updateExercise(id, newExercise));
  }

  saveExercise = (name, language, text, mode) => this.props.dispatch(createExercise({ name, language, text, mode, saveToGroup: true }));

  handleDeleteExercise = (id) => {
    this.handleClose();
    this.props.dispatch(deleteExercise(id));
  }

  renderExercise = (exercise, index) => {
    console.log(exercise);
    const disabled = this.props.isWaiting.EXERCISE_DELETE;
    const disabledModify = this.props.isWaiting.EXERCISE_UPDATE;

    const language = languageNames[exercise.language] || exercise.language;



    return <tr key={`exercise-${exercise.id}`}><td>{exercise.name}</td><td>{language}</td><td>{exercise.mode}</td><td>{exercise.creator}</td><td>{exercise.createdAt}</td><td><ModifyExercise isWaiting={this.props.isWaiting.EXERCISE_UPDATE} exercise={exercise} exercises={this.props.exercises} errors={this.props.exercises.errors} disabled={disabled} disabledModify={disabledModify} save={this.handleUpdateExercise} /></td><td><RaisedButton disabled={disabled} label="Delete" onTouchTap={ () => this.handleOpen(exercise) } /></td></tr>;
  }

  renderRemovalDialog() {
    if (!this.state.deleteExerciseDialog || this.state.exerciseForDeletion === null) {
        return <span></span>;
    }

    const exercise = this.state.exerciseForDeletion;

    const delLabel = this.props.isWaiting.EXERCISE_DELETE ? <CircularProgress size={20} /> : 'Yes, delete exercise';

    const actions = [
      <FlatButton
        label="No, cancel"
        primary
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        label={delLabel}
        primary
        onTouchTap={() => this.handleDeleteExercise(exercise.id)}
      />];

    return (
        <Dialog
          actions={actions}
          modal={false}
          open={this.state.deleteExerciseDialog}
          onRequestClose={this.handleClose}
        >
          Are you sure you want to delete this exercise?
          <br /><br />
          {exercise.name}<br /><br />
          {exercise.text}
        </Dialog>
      );
  }

  render() {
    const { validationErrors } = getErrors(this.props.errors);
    const nameErrorMessage = apiErrors[validationErrors.name] || validationErrors.name;
    const textErrorMessage = apiErrors[validationErrors.text] || validationErrors.text;

    const creationForm = this.state.showCreationForm
                          ? <CreateExerciseForm isWaiting={this.props.isWaiting} exercise={null} canSaveToGroup forceGroupSave nameErrorMessage={nameErrorMessage} textErrorMessage={textErrorMessage} saveExercise={this.saveExercise} />
                        : <span />;

                      const exercises = this.props.exercises.exercises.filter(e => e.group_id !== null);
                      exercises.sort((a,b) => b.id - a.id);
                      console.log(exercises);

    return (
      <div key="group-exercises">
      <Card className="card-wide">
        <CardHeader title="Edit your group's exercises" />
        <CardText>
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Language</th>
                <th>Mode</th>
                <th>Creator</th>
                <th>Created</th>
                <th />
                <th />
              </tr></thead>
            <tbody>
              {exercises.map(this.renderExercise)}
            </tbody>
          </table>

        </CardText>
        <Divider />
        <CardTitle title="Create a new exercise" showExpandableButton onTouchTap={() => this.setState({ showCreationForm: !this.state.showCreationForm })} />
        <CardText expandable children={creationForm} />
      </Card>
          {this.renderRemovalDialog()}
    </div>

    );
  }
}

export default GroupExercises;



// WEBPACK FOOTER //
// ./src/components/GroupExercises.js